<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6 login-section-wrapper">
        <div class="brand-wrapper">
          <img
            src="@/assets/images/brand/logo.png"
            alt="Findus logo"
            class="logo"
          />
        </div>
        <div class="login-wrapper my-auto" id="signup-wrapper">
          <h1 class="login-title">Registrati</h1>
          <small id="signup-hint">
            Sono abilitati alla registrazione solo utenti con e-mail @findus.it
            o @nomandfoods.com
          </small>
          <br>
          <div class="divider"></div>
          <small id="signup-description">
            Al termine della creazione dell'account, un'email di conferma sarà
            inviata all'indirizzo e-mail indicato. Quest'e-mail contiene un link
            che permette di terminare il processo di validazione dell'account.
            Solo un account validato potrà accedere alla piattaforma.
          </small>

          <form action="#!" class="mt-4">
            <div class="form-group">
              <label for="name">Nome</label>
              <input
                type="text"
                name="name"
                id="name"
                class="form-control"
                placeholder="John"
                v-model.trim="$v.firstName.$model"
              />
            </div>
            <div class="form-group mt-4">
              <label for="surname">Cognome</label>
              <input
                type="text"
                name="surname"
                id="surname"
                class="form-control"
                placeholder="Doe"
                v-model.trim="$v.lastName.$model"
              />
            </div>
            <div class="form-group mt-4">
              <label for="email">Email</label>
              <input
                type="email"
                name="email"
                id="email"
                class="form-control"
                placeholder="email@example.com"
                v-model.trim="$v.email.$model"
              />
            </div>
            <div class="form-group mb-4 mt-4">
              <label for="password">Password</label>
              <input
                type="password"
                name="password"
                id="password"
                class="form-control"
                placeholder="*****"
                v-model.trim="$v.password.$model"
              />
            </div>
            <LoadingButton
              :text="'Registrati'"
              :classes="['btn', 'btn-block', 'login-btn', 'w-100']"
              :loading="loading"
              :disabled="$v.$invalid"
              @click="signup()"
            />
          </form>
          <router-link :to="{ name: 'LoginPage' }" class="forgot-password-link"
            >Hai già un account? Accedi</router-link
          >
        </div>
      </div>
      <div class="col-sm-6 px-0 d-none d-sm-block">
        <img :src="image" alt="login image" class="login-img" />
      </div>
    </div>
  </div>
</template>

<script>
import { email, required } from "vuelidate/lib/validators";
import AuthService from "@/services/auth";

export default {
  data() {
    return {
      email: "",
      password: "",
      firstName: "",
      lastName: "",
      error: "",
      loading: false,
      image: "/static/images/login/findus_01.jpg",
    };
  },
  validations: {
    email: {
      email,
      required,
    },
    password: {
      required,
    },
    firstName: {
      required,
    },
    lastName: {
      required,
    },
  },
  methods: {
    getImage() {
      const images = [
        "/static/images/login/findus_01.jpg",
        "/static/images/login/findus_02.jpg",
        "/static/images/login/findus_03.jpg",
        "/static/images/login/findus_04.jpg",
        "/static/images/login/findus_05.jpg",
        "/static/images/login/findus_06.jpg",
        "/static/images/login/findus_07.jpg",
        "/static/images/login/findus_08.jpg",
        "/static/images/login/findus_09.jpg",
      ];

      this.image = images[Math.floor(Math.random() * images.length)];
    },
    async signup() {
      this.loading = true;

      try {
        const { data: message } = await AuthService.signup(
          this.email,
          this.password,
          this.firstName,
          this.lastName
        );

        if (message === "Dominio non autorizzato") {
          this.$toast.error("Impossibile registrare questo indirizzo email.");
        } else if (message !== "Sended") {
          this.$toast.error("Siamo spiacenti, si è verificato un errore.");
        } else if (message === "Sended") {
          location.href = "/verify-otp";
        }
      } catch (error) {
        this.$toast.error("Siamo spiacenti, si è verificato un errore.");
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getImage();
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/pages/login";
</style>



// WEBPACK FOOTER //
// src/pages/auth/signup/SignupPage.vue